import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  renderSelectField,
  renderCurrencyField,
  renderCLCurrencyField,
} from '../../../../../utils/redux-form-helper';
import messages from './messages';
export const OneTimeLeaseChargesOrCreditsRightColumn = ({
  intl,
  securityDeposits,
  isEditable,
  handleAutoFilledFieldChange,
  autoFilledLeaseChargeFields,
  autoPopulatedFieldsAreEditable,
}: Object) => {
  const getBackgroundColor = (fieldName) =>
    autoFilledLeaseChargeFields[fieldName] ? 'warning.lighter' : undefined;
  const { automatedLeaseChargesP1 } = useFlags();
  return (
    <Col xs={12} sm={6}>
      <Row>
        <Col xs={7}>
          <label>
            {intl.formatMessage(messages.securityDepositAlternativeLabel)}
          </label>
        </Col>
        <Col xs={5}>
          <Field
            name="securityDepositAlternativeId"
            component={renderSelectField}
            options={securityDeposits}
            disabled={!isEditable}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <label>
            {intl.formatMessage(
              automatedLeaseChargesP1
                ? messages.administrativeFeeLabel
                : messages.nonRefundableAdminFeeLabel,
            )}
          </label>
        </Col>
        <Col xs={5}>
          <div className="form-group">
            <Field
              name="nonRefundableAdminFee"
              component={
                automatedLeaseChargesP1
                  ? renderCLCurrencyField
                  : renderCurrencyField
              }
              step="0.01"
              disabled={!autoPopulatedFieldsAreEditable}
              onChange={(_, value) => {
                if (!automatedLeaseChargesP1) {
                  return;
                }

                handleAutoFilledFieldChange('nonRefundableAdminFee', value);
              }}
              InputProps={
                automatedLeaseChargesP1 && {
                  sx: {
                    backgroundColor: getBackgroundColor(
                      'nonRefundableAdminFee',
                    ),
                  },
                }
              }
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <label>{intl.formatMessage(messages.satelliteDepositLabel)}</label>
        </Col>
        <Col xs={5}>
          <div className="form-group">
            <Field
              name="satelliteDeposit"
              component={renderCurrencyField}
              step="0.01"
              disabled={!isEditable}
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};
